import * as React from "react";
import { IPage } from "../models/IPage.model";

const BasketContext = React.createContext<IPage | null>(null);

export default BasketContext;
